export default __webpack_public_path__ + "images/773e8b9a1e0ef03c7258c501e44f2dec-sinacofi.svg";